var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4215 8.68892C16.4215 8.11045 16.375 7.53199 16.2819 6.96533H8.38086V10.2354H12.9074C12.7212 11.2861 12.1161 12.2305 11.2317 12.8208V14.9458H13.9313C15.5139 13.4701 16.4215 11.2861 16.4215 8.68892Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38103 16.9996C10.6385 16.9996 12.5468 16.2441 13.9315 14.9455L11.2319 12.8205C10.4756 13.34 9.50975 13.6351 8.38103 13.6351C6.19342 13.6351 4.34325 12.1358 3.67999 10.1289H0.898926V12.3247C2.31855 15.1934 5.21597 16.9996 8.38103 16.9996Z",
    fill: "#AAAAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68055 10.1298C3.33141 9.0791 3.33141 7.93398 3.68055 6.8715V4.6875H0.899043C-0.299681 7.08399 -0.299681 9.91729 0.899043 12.3138L3.68055 10.1298Z",
    fill: "#AAAAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38103 3.36505C9.57957 3.34144 10.7316 3.80185 11.5926 4.64003L13.9897 2.20812C12.4654 0.767864 10.4639 -0.023097 8.38103 0.000513782C5.21597 0.000513782 2.31855 1.81854 0.898926 4.68725L3.67999 6.88305C4.34325 4.86433 6.19342 3.36505 8.38103 3.36505Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepay);
export default __webpack_public_path__ + "static/media/googlepay.913d6d44972dddbb11b9aae1a786e58f.svg";
export { ForwardRef as ReactComponent };